<ul [class]="'display-not-mobile ' + clazz + ' length-' + tabs.length">
  @for (tab of tabs; track tab) {
    <li (click)="selectTab(tab)" [class.active]="tab.active">
      <pr-label
        [name]="tab.icon"
        labelDefaultClass="fw-600"
        [labelClass]="
          defaultTextColor ? (tab.active ? 'text-white' : 'text-dark') : ''
        "
        >{{ tab.label }}</pr-label
      >
    </li>
  }
</ul>
<ng-content></ng-content>
<ul [class]="'display-mobile ' + clazz + ' length-' + tabs.length">
  @for (tab of tabs; track tab) {
    <li (click)="selectTab(tab)">
      @if (tab.active) {
        <svg
          width="32"
          height="9"
          viewBox="0 0 32 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect y="0.116943" width="32" height="8" rx="4" fill="#3376F6" />
        </svg>
      }
      @if (!tab.active) {
        <svg
          width="8"
          height="9"
          viewBox="0 0 8 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect y="0.116943" width="8" height="8" rx="4" fill="#3376F6" />
        </svg>
      }
    </li>
  }
</ul>
